export const FirebaseConfig = {
	"projectId": "reaplnprge",
	"appId": "1:154787637891:web:c03631f68cd9f3026089b6",
	"databaseURL": "https://reaplnprge.firebaseio.com",
	"storageBucket": "reaplnprge.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyDmfyl4PgU3SxHiztsZ8PlCPzOPXqi5r3E",
	"authDomain": "reaplnprge.firebaseapp.com",
	"messagingSenderId": "154787637891"
};
